// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateRecordAuditVisibility = (state, action) => action.visibility;

export default (state = getDefaultState().isRecordAuditModalVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_RECORD_AUDIT_MODAL_VISIBILITY]: updateRecordAuditVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/reducers/is-record-audit-modal-visible.js